import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translocoService = inject(TranslocoService);

  currentLanguage = toSignal(this.translocoService.langChanges$, {
    initialValue: this.getInitialLanguage(),
  });

  constructor() {
    const lang = this.getInitialLanguage();
    this.translocoService.setDefaultLang('es');
    this.translocoService.setActiveLang(lang);

    this.translocoService.langChanges$.subscribe((activeLang) => {
      localStorage.setItem('lang', activeLang);
    });
  }

  changeLanguage(lang: string): void {
    this.translocoService.setActiveLang(lang);
    localStorage.setItem('lang', lang);
  }

  getCurrentLanguage(): string {
    return this.translocoService.getActiveLang();
  }

  private getInitialLanguage(): string {
    return localStorage.getItem('lang') || 'es';
  }
}
